import React from "react";
import { useSelector } from "react-redux";
import PrimaryBtn from "../../buttons/PrimaryBtn";
import SecondaryBtn from "../../buttons/SecondaryBtn";
import classes from "./FooterPopup.module.css"

const FooterPopup = ({ children, onClose, next, nextText, classNameNext, classNameCancel, disabled, className }) => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={`${classes.Footer} ${className || ""}`}>
            {onClose && <SecondaryBtn dropClass={`${classes.Cancel} ${classNameCancel}`} onClick={() => onClose()}>
                {texts.cancel}
            </SecondaryBtn>}
            {children}
            {next && <PrimaryBtn
                dropClass={`${classNameNext} ${classes.Next} ${disabled ? classes.Disabled : ""}`}
                onClick={() => !disabled && next()}
                disabled={disabled}
            >
                {nextText || texts.continue}
            </PrimaryBtn>}
        </div>
    )
}

export default FooterPopup;  